import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "./GalleryDetaile.css";
import { useDispatch, useSelector } from "react-redux";
import { Button, Carousel } from "react-bootstrap";
import { SendToCart } from "../Redux/AddToCartRedux";
import { Toast } from "primereact/toast";

function GalleryDetaile(props) {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.gallery);
  let DilogBoxData = posts.data?.filter(function (el) {
    return el.UID === props.uid;
  })[0];

  const posts2 = useSelector((state) => state.AddToCart);
  const IsLogin = useSelector((state) => state.GlobalStatus.data);
  if (typeof DilogBoxData === "undefined") {
    DilogBoxData = {
      Artist: "",
      Details: "",
      Dimensions: "",
      HashTags: "",
      Name: "",
      Price: "",
      Qty: "",
      Type: "",
      UID: "",
      NoImages: 0,
    };
  }
  const toast = useRef(null);
  const showSuccess = (Message) => {
    toast.current.show({
      severity: "success",
      summary: "Added to Cart",
      detail: Message,
      life: 1000,
    });
  };
  let ImageDisplay = [];
  for (let a = 0; a < DilogBoxData["NoImages"]; a++) {
    ImageDisplay.push(
      <Carousel.Item key={DilogBoxData["UID"] + "C" + (a + 1).toString()}>
        <img
          className="Photos02"
          src={
            // process.env.REACT_APP_BackEndIP+"/Static/Art/" +DilogBoxData["UID"] +"/" +(a + 1).toString() +".png"
         `${process.env.REACT_APP_BackEndIP}/Static/Art/${DilogBoxData["UID"]}/${(a + 1).toString()}.png?${new Date().getTime()}`
           }
          alt="Not Available"
        />
      </Carousel.Item>
    );
  }
  const AddToCart = (Name, Value, event) => {
    dispatch(SendToCart(Value));
    showSuccess(Name + " is being Added to Cart");

    event.stopPropagation();
  };

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="lg">
      <Toast ref={toast} position="bottom-center" />
      <Modal.Header closeButton className="Titel02">
        <Modal.Title id="contained-modal-title-vcenter">
          {DilogBoxData["Name"]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="ArtBox02">
        <div className="PhotosFrame02">
          <Carousel data-bs-theme="dark">{ImageDisplay}</Carousel>
        </div>
        <div className="TextFrame02">
          <p>
            <strong>Id: </strong>
            {DilogBoxData["UID"]}
            <br></br>
            <strong>Artist: </strong>
            {DilogBoxData["Artist"]}
            <br></br>
            <strong>Dimensions: </strong>
            {DilogBoxData["Dimensions"]}
            <br></br>
            <strong>Qty: </strong>
            {DilogBoxData["Qty"]}
            <br></br>
            <strong>Rs: </strong>
            {DilogBoxData["Price"]}
            <br></br>
            <strong>Details: </strong>
            {DilogBoxData["Details"]}
            <br></br>

            {IsLogin["IsLogedIn"] ? (
              posts2["isLoading"] ? (
                <Button className="Button07">Adding... To Cart</Button>
              ) : (
                <>
                  {parseInt(DilogBoxData["Qty"]) >
                  parseInt(DilogBoxData["CQty"]) ? (
                    <>
                      {DilogBoxData["CQty"] === "0" ? (
                        <Button
                          onClick={(event) =>
                            AddToCart(
                              DilogBoxData["Name"],
                              DilogBoxData["UID"],
                              event
                            )
                          }
                          className="Button07"
                        >
                          Add To Cart
                        </Button>
                      ) : (
                        <Button
                          onClick={(event) =>
                            AddToCart(
                              DilogBoxData["Name"],
                              DilogBoxData["UID"],
                              event
                            )
                          }
                          className="Button07"
                        >
                          {"Add Again To Cart (" + DilogBoxData["CQty"] + ")"}
                        </Button>
                      )}
                    </>
                  ) : (
                    <Button className="Button07">
                      Reached Max Qty Can't Add to Cart
                    </Button>
                  )}
                </>
              )
            ) : null}
            {/* <strong>Type: </strong>{DilogBoxData["Type"]}<br></br> */}
            {/* <strong>HashTag: </strong>{DilogBoxData["HashTags"]}<br></br> */}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default GalleryDetaile;
